import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 20h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "16", cy: "20", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "20", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Luggage";
const Luggage = memo(themed(Icon));
export {
  Luggage
};
//# sourceMappingURL=luggage.js.map
